/**
 * @generated SignedSource<<cebb8c52ad66af9840ef2d782e704e47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryDetailQuery$variables = {
  piece_id: string;
};
export type LibraryDetailQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"LibraryDetailBody_piece">;
    };
  };
};
export type LibraryDetailQuery = {
  variables: LibraryDetailQuery$variables;
  response: LibraryDetailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "piece_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LibraryDetailBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LibraryDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "edf3e4ceaed4c08f09f6ffe1089f7f46",
    "id": null,
    "metadata": {},
    "name": "LibraryDetailQuery",
    "operationKind": "query",
    "text": "query LibraryDetailQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    piece(id: $piece_id) {\n      id\n      ...LibraryDetailBody_piece\n    }\n  }\n}\n\nfragment LibraryDetailBody_piece on MusicPiece {\n  id\n  name\n  status\n}\n"
  }
};
})();

(node as any).hash = "9ef4391f4b477710ad9176047c780225";

export default node;
